import { put, takeLatest } from 'redux-saga/effects';

import { api, makeRequest } from 'shared/sdk';

const actionPrefix = 'GlobalSearch/';
const FETCH_VENDORS = `${actionPrefix}FETCH_VENDORS`;
const SUCCESS_FETCH_VENDORS = `${actionPrefix}SUCCESS_FETCH_VENDORS`;
const FAIL_FETCH_VENDORS = `${actionPrefix}FAIL_FETCH_VENDORS`;

export const fetchVendors = args => ({
  type: FETCH_VENDORS,
  payload: args
});

export const successFetchVendors = payload => ({
  type: SUCCESS_FETCH_VENDORS,
  payload
});

export const failFetchVendors = payload => ({
  type: FAIL_FETCH_VENDORS,
  payload
});

export const vendorsReducer = (state, action) => {
  switch (action.type) {
    case FETCH_VENDORS:
      state['fetchingVendors'] = true;
      break;

    case SUCCESS_FETCH_VENDORS:
      state['vendors'] = action.payload.results;
      state['vendorsCount'] = action.payload.count;

      state['fetchingVendors'] = false;
      break;

    default:
      return state;
  }
};

function* fetchVendorsWorker(action) {
  const response = yield makeRequest(api.companiesList, {
    requestData: { params: { limit: 4, ...action.payload } }
  });

  if (response.success) yield put(successFetchVendors(response.data));
  else yield put(failFetchVendors(response.errors));
}

export function* vendorsWatcher() {
  yield takeLatest(FETCH_VENDORS, fetchVendorsWorker);
}
